import { jsx as _jsx } from "react/jsx-runtime";
import * as RadixHoverCardPrimitive from '@radix-ui/react-hover-card';
import * as RadixPopoverPrimitive from '@radix-ui/react-popover';
export function PopoverPrimitiveArrow(props) {
    if (props.shouldShowArrow !== true) {
        return null;
    }
    const { interaction, arrowSlotProps } = props;
    const radixArrowProps = arrowSlotProps?.children != null
        ? {
            // A custom child replaces the default arrow element.
            asChild: true,
            children: arrowSlotProps.children,
        }
        : {
            // Without a custom child, the default SVG uses the requested dimensions.
            width: arrowSlotProps?.width,
            height: arrowSlotProps?.height,
        };
    const sharedProps = {
        ...radixArrowProps,
        className: arrowSlotProps?.className,
        style: arrowSlotProps?.style,
    };
    if (interaction === 'hover') {
        return _jsx(RadixHoverCardPrimitive.Arrow, { ...sharedProps });
    }
    return _jsx(RadixPopoverPrimitive.Arrow, { ...sharedProps });
}
//# sourceMappingURL=PopoverPrimitiveArrow.js.map